module.exports = Promise.all([parcelRequire.load("eMPWC"), parcelRequire.load("3uqLB")]).then(() => parcelRequire('1A9qR'));